import { render } from "./LicenceView.vue?vue&type=template&id=f047a37a"
import script from "./LicenceView.vue?vue&type=script&lang=js"
export * from "./LicenceView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/apiffare/projects/norbert-weston/norbert-weston-1/apps/norbert-weston-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__